import { render, staticRenderFns } from "./DialogImgViewer.vue?vue&type=template&id=4fd8e46a&"
import script from "./DialogImgViewer.vue?vue&type=script&lang=js&"
export * from "./DialogImgViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports